<template>
    <div class="banner_bg" v-bind:style="{backgroundImage:'url('+src+')'}">
    </div>
</template>

<script>
  export default {
    name: "bannerBg",
    data() {
      return {
        src: require('@/assets/images/about.jpg')
      };
    }
  };
</script>
<style>
</style>